import { render, staticRenderFns } from "./BindWechat.vue?vue&type=template&id=83a6a866&scoped=true"
import script from "./BindWechat.vue?vue&type=script&lang=js"
export * from "./BindWechat.vue?vue&type=script&lang=js"
import style0 from "./BindWechat.vue?vue&type=style&index=0&id=83a6a866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a6a866",
  null
  
)

export default component.exports